<template>
    <div>
        <div class="w-full md:w-4/5 m-auto py-6 px-12">

            <div class="bg-white text-left mb-1 p-8 border border-gray-300 rounded">

                <div v-if="verified === true">
                    <p class="mb-4 text-green-600 text-2xl">Email address verified</p>
                    <p>You may now log in. Redirecting to the login page...</p>
                </div>
                <div v-else>
                    <p class="mb-4 text-green-600 text-2xl">Attempting to verify your email address...</p>
                    <p>Verifying...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import store from '@/store';

export default {
    name: 'VerifyEmail',
    components: {},
    data() {
        return {
            hash: this.$route.params.hash ?? '',
            verified: false,
        }
    },
    mounted() {
        this.verifyHash()
    },
    methods: {
        redirect() {
            window.location.href = '/'
        },
        verifyHash() {
            if (this.hash.length > 0)
            {
                this.$store.dispatch('verifyHash', {
                    hash: this.hash,
                })
                    .then(() => {
                        this.$store.commit('verifiedEmail')
                        this.verified = true
                        setTimeout(() => {
                            this.redirect()
                        }, 1500)
                    })
                    .catch(() => {

                    })
            }

        },
    },

}
</script>
